module.exports = __webpack_public_path__ + "img/time-funnel_black.e20d2a17.png";